import { Component, HostListener, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ChartsService } from 'src/app/services/charts.service';
import { ClickStreamService } from 'src/app/services/click-stream.service';

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})
export class ChartComponent implements OnInit {
  @Input() chart: any;
  hasChart: boolean = false;
  @Input() hasModal: boolean = false;
  isMobile: boolean = false;
  chartDataError = null;
  hasNoData = false;
  loading = true;

  isGrid = false;
  screenWidth;
  screenHeight;

  constructor(private chartsService: ChartsService, public dialog: MatDialog, private clickstream: ClickStreamService) { }

  ngOnInit(): void {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (!this.chart.chartData && !this.chart.chartError) { // the case when we just have the guid
      this.chartsService.getChart(this.chart.chartDataGuid).subscribe((res : any) => {
        this.chart.chartData = res;
        this.chart.chartData.data = res.chartData.data;
        this.loading = false;
      })
    } else {
      if (this.chart.chartError) {
        this.chartDataError = this.chart.chartError;
      } else {
        this.chart.chartData.data = this.chart.chartData.chartData.data;
      }
      this.loading = false;
    }
    if (window.innerWidth < 1026) {
      this.isMobile = true;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (window.innerWidth < 1026) this.isMobile = true;
  }

  // openModal() {
  //   if (this.hasModal && !this.isMobile && !this.chartDataError) {
  //     this.dialog.open(ChartModalComponent, { data: { chartData: this.chartData, config: this.maxisChartConfig, isTextCard: this.isTextChart, isGrid: this.isGrid, hasChart: this.hasChart, chartType: this.maxisChart.chartType } });
  //     this.clickstream.send('chart-click', 'click', 'Dashboard', 'Chart', '', true);
  //   }
  // }
}
